import React from 'react';
import { isEqual } from 'lodash';

export function useDeepDeps(deps) {
  const depsRef = React.useRef(deps);
  const ref = React.useRef(1);
  if (!isEqual(deps, depsRef.current)) {
    ref.current += 1;
    depsRef.current = deps;
  }
  return ref.current;
}
